'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _ArrowRightOutlined = _interopRequireDefault(require('./lib/icons/ArrowRightOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _ArrowRightOutlined;
exports.default = _default;
module.exports = _default;